module.exports = __webpack_public_path__ + "img/office.e7bac85b.jpg";